import { createClient } from '@sanity/client';
import { createImageUrlBuilder } from '@sanity/image-url';
import JsonResponse from '../../../js/cloudflare/JsonResponse';
import type { JsonApiFunction } from '../../../js/cloudflare/types';
import { getImageUrl } from '../../../js/sanity/components/SanityImage';
import type { WineStyleProps } from '../../../js/sanity/components/WineStyle';
import { wineStyleGroq } from '../../../js/sanity/components/WineStyle';
import { getConfig } from '../../../js/sanity/infrastructure/getConfig';

export interface GetResponseBody {
    wineStyle: WineStyleProps & { image: { url?: string } };
    projectId: string;
    dataset: string;
}

export const pathname = '/api/wineStyle/[id]' as const;

export const onRequestGet: JsonApiFunction<typeof pathname, never, GetResponseBody> = async ({ request, env, data, params }) => {
    const config = getConfig({ env, data });
    const client = createClient(config);

    const queryParams = new URL(request.url).searchParams;

    const response = await client.fetch<GetResponseBody>(
        /* groq */ `
      {
        'wineStyle': *[_type == 'wineStyle' && hybrisReference == $id][0]${wineStyleGroq},
        'projectId': $projectId,
        'dataset': $dataset
      }
    `,
        { projectId: config.projectId, dataset: config.dataset, id: params.id },
    );

    const width = parseInt(queryParams.get('w') ?? '', 10);
    const height = parseInt(queryParams.get('h') ?? '', 10);
    if (width && height) {
        const imageBuilder = createImageUrlBuilder(client);
        if (response.wineStyle.image) {
            response.wineStyle.image.url = getImageUrl(response.wineStyle.image, width, width / height, imageBuilder);
        }
    }

    return new JsonResponse(response, {
        headers: {
            'Cache-Control': `public, s-maxage=${5 * 60}, stale-while-revalidate=30`,
        },
    });
};
